import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2" }
const _hoisted_2 = { class: "text-md font-bold" }
const _hoisted_3 = { class: "truncate overflow-hidden text-left" }

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    name: {}
  },
  setup(__props: any) {

const props = __props;



const initials = computed(() => {
  if (!props.name) return ''
  return props.name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .substring(0, 2)
    .toUpperCase()
})

return (_ctx: any,_cache: any) => {
  const _component_v_avatar = _resolveComponent("v-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_avatar, {
      color: "primary",
      size: "32"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(initials.value), 1)
      ]),
      _: 1
    }),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1)
  ]))
}
}

})